
import { NavigationTranslationType } from "../../features/navigation.types";

export const navigation: NavigationTranslationType = {
  navigation: {
    dashboard: "Nadzorna plošča",
    profile: "Profil",
    signOut: "Odjava",
    upgradeRequired: "Potrebna nadgradnja",
    basicSubscriptionRequired: "Zahtevana osnovna naročnina",
    premiumSubscriptionRequired: "Zahtevana premium naročnina",
  }
};
